import React from "react";
import {useStateContext} from "../../helpers/state-context/use_state_context.js";
import parse from 'html-react-parser';
import CloseIcon from '../../assets/close_S.svg'

const CountryHeader = function(props){
    const {classNamePrefix, title, onClose} = props;
    const [state, dispatch] = useStateContext(['country', 'selectedCategory']);

    return <div className={'header-wrapper'}>
        <div className={`${classNamePrefix}-header`}>
            <h2 className={`${classNamePrefix}-header-title`}>{parse(title)}</h2>
            <img className={`${classNamePrefix}-close`}
                 alt={`${classNamePrefix}-close`}
                 src={CloseIcon}
                 onClick={(e)=>{
                    dispatch({type: 'countryHover', value: null});
                    dispatch({type: 'country', value: null});
                    dispatch({type: 'page', value: null});
                    if(classNamePrefix === 'info' && state.selectedCategory){
                        dispatch({type: 'selectedCategory', value: null});
                        dispatch({type: 'setDefaultCategories'});
                    }
                    if(onClose){
                        onClose()
                    }
                 }}
            />
        </div>
    </div>
};

CountryHeader.defaultProps = {
    classNamePrefix: 'country'
}

export {CountryHeader}